import { render, staticRenderFns } from "./coursePageEdit.vue?vue&type=template&id=138522e8&"
import script from "./coursePageEdit.vue?vue&type=script&lang=js&"
export * from "./coursePageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports